module.exports = __webpack_public_path__ + "static/img/bg-1.b675d3aa.png";